import { Drawer, Button, List } from "rsuite";
import type { Terminal } from "../../../../../my-type";

interface AirportDrawerProps {
  open: boolean;
  terminals: Terminal[];
  onClose: () => void;
  onSelect: (terminal: Terminal) => void;
}

export const AirportDrawer: React.FC<AirportDrawerProps> = ({
  open,
  terminals,
  onClose,
  onSelect
}) => {
  return (
    <Drawer size="xs" placement="left" open={open} onClose={onClose}>
      <Drawer.Header>
        <Drawer.Title>選擇機場</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose}>取消</Button>
          <Button onClick={onClose} appearance="primary">
            確認
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <List>
          {terminals.map((terminal, index) => (
            <List.Item key={index}>
              <Button
                appearance="subtle"
                onClick={() => {
                  onSelect(terminal);
                  onClose();
                }}
              >
                {terminal.name}
              </Button>
            </List.Item>
          ))}
        </List>
      </Drawer.Body>
    </Drawer>
  );
};
